export async function request(request) {
    const response = await fetch(request);
    try {
        /* DEBUG php api
        const text = await response.text();
        console.log(text);*/
        const body = await response.json();
        response.parsedBody = body.body;
        response.apiResponseStatus = body.apiResponseStatus;
    }
    catch (ex) { }
    return response;
}
//# sourceMappingURL=httphelper.js.map